// extracted by css-extract-rspack-plugin
var _1 = "YcOfikRXwwIkj9BR";
export { _1 as "markdownText" }
// extracted by css-extract-rspack-plugin
var _1 = "YcOfikRXwwIkj9BR";
export { _1 as "markdownText" }
